export const BET_RADAR_PROVIDER = 'SS247';
export const IMG_PROVIDER = 'IMG';

// provided by operator
export const BET_RADAR_VIDEO_PLAYER_WIDTH = 500;
export const BET_RADAR_VIDEO_PLAYER_HEIGHT = 281;
export const BET_RADAR_VIDEO_PLAYER_HEIGHT_COEFFICIENT = 0.562;
